import _ from "lodash";
import React, {useContext, useEffect, useState} from "react";
import {Link} from "react-router-dom";
import Config from "../../../config";
import { ShopContext } from "../../../context/ShopContext";
import {CatalogueContext} from "../../../context/CatalogueContext"
import {Redirect} from "react-router-dom";
import {Button} from "../../../components/controls";
import {ErrorScreen, LoadingScreen, Scaffolding} from "../../shared";

function InitializePayment() {
  // shop context
  const SC = useContext(ShopContext);
  const CC = useContext(CatalogueContext);
  // state
  const [gatewayError, setGatewayError] = useState(null);
  const [redirectTo, setRedirectTo] = useState(null);
  /**
   * Fetches a payrexx gateway from server
   */
  const getGateway = async() => {
    const result = await SC.cart.initializePayrexx();
    if(result.ok) {
      if(result.payrexxGateway && result.payrexxGateway.link) {
        // redirect to payment page
        window.location.href = result.payrexxGateway.link;
      }
    }
    else {
      setGatewayError(_.get(result, "error.message") || "unbekannter Fehler");
      // an error at this point most likely is due to activities having their price changed - we (rather unelegantly) empty the cart in that case
      // if we get a httpStatus: 403 Payrexx complained about our request to create a gateway not having a valid signature (this happened when parameters had spaces in them)
      //SC.cart.removeAllActivities();  
    }
  }

  // mount
  useEffect(() => {
    if(CC.isReady) {
      getGateway();
    }
  }, [CC.isReady])

  // redirect?
  if(redirectTo) {
    return <Redirect to={redirectTo} />
  }

  // render
  let content = <LoadingScreen mode="initializePayment" />
  if(gatewayError) {
    content = (
      <Scaffolding>
        <ErrorScreen 
          title="Zahlung konnte nicht initiiert werden" 
          buttonTitle="zurück zum Checkout"
          onButtonClick={() => setRedirectTo("/checkout")}
        >
          <p>Leider konnte der Zahlungsvorgang nicht gestartet werden</p>
          <p>Versuche es nochmals oder verwende stattdessen als Zahlungsart Rechnung</p>
        </ErrorScreen>
      </Scaffolding>
    )
  }
  return content;
}

export default InitializePayment

